<div class="modal-header">
  <h5 class="modal-title" id="font-picker-title">Select a font</h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('cancel')"></button>
</div>

<div class="font-picker-filter">
  <div class="font-picker-filter-row">
    <div class="font-picker-search">
      <!-- Focus stays here while Up and Down move through the list, so the field points screen readers at the row. -->
      <input #searchInput type="text" class="form-control form-control-sm" placeholder="Search" aria-label="Search fonts"
             spellcheck="false" autocomplete="off" ngbAutofocus
             role="combobox" aria-expanded="true" aria-autocomplete="list" aria-controls="font-picker-list"
             aria-describedby="font-picker-keys"
             [attr.aria-activedescendant]="activeRowId()"
             [value]="search()" (input)="search.set(searchInput.value)"/>
      @if (search()) {
        <button type="button" class="font-picker-search-clear" aria-label="Clear search" (click)="clearSearch(searchInput)">
          <i class="fa-solid fa-circle-xmark" aria-hidden="true"></i>
        </button>
      }
    </div>
    <!-- Each option says whether it is selected: a [value] on the select is set before the @for adds its options. -->
    <select class="form-select form-select-sm" aria-label="Language" (change)="setLanguage($any($event.target).value)">
      <option value="" [selected]="!language()">All languages</option>
      @for (option of languages; track option.value) {
        <option [value]="option.value" [selected]="option.value === language()">{{ option.label }}</option>
      }
    </select>
  </div>
  <div class="font-picker-categories" role="group" aria-label="Categories">
    @for (category of categoryNames; track category) {
      <button type="button" class="font-picker-pill" [class.checked]="categories().includes(category)"
              [attr.aria-pressed]="categories().includes(category)" (click)="toggleCategory(category)">{{ category }}</button>
    }
  </div>
</div>

<div class="font-picker-sample" contenteditable="true" spellcheck="false" title="Sample text, editable"
     [style.font-family]="sample() ? fontStack(sample().family, sample().category) : null">The quick brown fox jumps over the lazy dog.</div>

<p id="font-picker-keys" class="visually-hidden">Up and Down move through the fonts, Enter selects one, Shift+Enter adds it to or removes it from your favourites.</p>

<div class="font-picker-body">
  <cdk-virtual-scroll-viewport class="font-picker-list" [itemSize]="rowHeight" minBufferPx="72" maxBufferPx="216"
                               id="font-picker-list" role="listbox" aria-label="Fonts" tabindex="0"
                               aria-describedby="font-picker-keys"
                               [attr.aria-activedescendant]="activeRowId()">
    <div *cdkVirtualFor="let row of rows(); let index = index; trackBy: trackRow" class="font-picker-slot">
      @if (row.kind === 'divider') {
        <div class="font-picker-divider" role="presentation">{{ row.label }}</div>
      } @else {
        <div class="font-picker-row" role="option" [id]="'font-picker-row-' + index"
             [attr.aria-label]="row.font.family + ', ' + row.font.category + (isFavourite(row.font) ? ', favourite' : '')"
             [class.active]="row.key === activeKey()" [attr.aria-selected]="row.key === activeKey()"
             (mouseenter)="sample.set(row.font)" (click)="activate(row)" (dblclick)="choose(row.font)">
          <span class="font-picker-name" [style.font-family]="fontStack(row.font.family, row.font.category)">{{ row.font.family }}</span>
          <small>{{ row.font.category }}</small>
          @if (row.key === activeKey()) {
            <!-- For the mouse only: the keys in font-picker-keys do the same from the keyboard. -->
            <span class="font-picker-row-actions" aria-hidden="true" (dblclick)="$event.stopPropagation()">
              <button type="button" class="font-picker-favourite" [class.checked]="isFavourite(row.font)"
                      tabindex="-1" title="Favourite (Shift+Enter)" (click)="$event.stopPropagation(); toggleFavourite(row.font)">
                <i [class]="isFavourite(row.font) ? 'fa-solid fa-heart' : 'fa-regular fa-heart'" aria-hidden="true"></i>
              </button>
              <button type="button" class="btn btn-sm btn-light" tabindex="-1" (click)="$event.stopPropagation(); choose(row.font)">Select</button>
            </span>
          }
        </div>
      }
    </div>
  </cdk-virtual-scroll-viewport>
  @if (loadFailed()) {
    <div class="font-picker-status" role="alert">The fonts could not be loaded. Close this and try again.</div>
  } @else if (fonts() === null) {
    <div class="font-picker-status">Loading fonts…</div>
  } @else if (!rows().length) {
    <div class="font-picker-status">No fonts match.</div>
  }
</div>
